export const universalCsp = {
  'default-src': ["'self'"],
  'font-src': [
    "'self'",
    'https://fonts.gstatic.com/',
    'https://app.getbeamer.com/',
    'data:',
    'cdn.eu.pendo.io'
  ],
  'style-src': [
    "'self'",
    "'unsafe-inline'",
    'cdn.eu.pendo.io',
    'pendo-eu-static-6259707017494528.storage.googleapis.com',
    'app.eu.pendo.io'
  ],
  'style-src-elem': [
    "'self'",
    'https://api.tiles.mapbox.com/',
    'https://fonts.googleapis.com/',
    'https://wchat.eu.freshchat.com/',
    'https://app.getbeamer.com/',
    "'unsafe-inline'"
  ],
  'script-src': [
    "'self'",
    "'unsafe-eval'",
    "'sha256-cjeHmUT8tPYJL6GbVRyK0g+jkI57j4xwcA0JNZvyH7s='",
    'blob:',
    'cdn.eu.pendo.io',
    'pendo-eu-static-6259707017494528.storage.googleapis.com',
    'app.eu.pendo.io',
    'data:'
  ],
  'script-src-elem': [
    "'self'",
    'blob:',
    "'unsafe-inline'",
    'https://app.usercentrics.eu',
    'https://maps.googleapis.com',
    'https://images.sabscorp.com',
    'https://*.usercentrics.eu',
    'https://unpkg.com',
    'https://api.tiles.mapbox.com/',
    'https://cdn.jsdelivr.net/',
    'https://www.google-analytics.com/',
    'https://app.getbeamer.com/',
    'https://wchat.eu.freshchat.com',
    'https://*.pendo.io/',
    'http://cdn.pendo.io'
  ],
  'img-src': [
    "'self'",
    'data:',
    // Google Charts API (used for hotel map loading indicators)
    'https://chart.apis.google.com',
    // Sqills template domains (all environments)
    'https://template.rdg-bat-gw-acc.cloud.sqills.com',
    'https://template.rdg-bat-gw-prod.cloud.sqills.com',
    'https://template.rdg-bat-gr-acc.cloud.sqills.com',
    'https://template.rdg-uk-gr-prod.cloud.sqills.com',
    'https://template.rdg-bat-tp-acc.cloud.sqills.com',
    'https://template.rdg-bat-vt-acc.cloud.sqills.com',
    'https://template.rdg-uk-xc-prod.cloud.sqills.com',
    'https://template.rdg-uk-vt-prod.cloud.sqills.com',
    'https://template.rdg-uk-gw-prod.cloud.sqills.com',
    'https://template.rdg-uk-em-prod.cloud.sqills.com',
    // Sabre and travel services
    'https://*.sabre.com',
    'https://images.sabscorp.com',
    'https://media.iceportal.com',
    'https://secure.holidayextras.co.uk',
    'https://d1xcii4rs5n6co.cloudfront.net',
    'https://i.travelapi.com',
    'https://hotelbookerssl.sabre.com',
    'https://ssl.conferma.com',
    'https://static4.holidayextras.com',
    'https://scoutfroneasset.blob.core.windows.net',
    'https://upamedia.atpco.net',
    'https://arrangemy.com',
    'https://investor.travelctm.com.au',
    // Third-party services
    'https://*.usercentrics.eu',
    'https://app.getbeamer.com/',
    'https://www.google.com',
    'https://www.google.co.uk',
    'https://www.google-analytics.com',
    'https://*.pendo.io/',
    'https://*.groundspan.com',
    'https://maps.gstatic.com',
    'https://maps.googleapis.com',
    'https://lh3.ggpht.com',
    'https://streetviewpixels-pa.googleapis.com',
    'cdn.eu.pendo.io',
    'app.eu.pendo.io',
    'pendo-eu-static-6259707017494528.storage.googleapis.com',
    // Evolvi seatmap images (per-TOC S3 buckets, e.g. itp-inv-public-*, s3p-inv-public-*)
    'https://*.s3.eu-central-1.amazonaws.com'
  ],
  'connect-src': [
    "'self'",
    'data:',
    // Local development
    'http://localhost:1234',
    // Production domains
    'https://www.ctmlightning.co.uk',
    'https://www.sabsenterprise.com',
    // CSP Reports Logging
    'https://logserver01.sabstt.com',
    // CDNs and external services
    'https://d1xcii4rs5n6co.cloudfront.net',
    'https://secure.holidayextras.co.uk',
    'https://*.sabre.com',
    'https://unpkg.com/@googlemaps/',
    'https://images.sabscorp.com',
    'https://test.trips.uk.com/',
    'https://maps.gstatic.com/',
    'https://fonts.googleapis.com',
    'https://app.getbeamer.com',
    'https://maps.googleapis.com',
    // Azure services
    'https://scout-eu-nlu-dev.azurewebsites.net',
    'https://scout-advertisement-server.azurewebsites.net',
    'https://scout-global-app.azurewebsites.net',
    // CTM Portal endpoints
    'https://approve-test.ctmportal.co.uk',
    // Auth services
    'https://*.auth0.com',
    'https://ctmuk-dev.eu.auth0.com',
    // Analytics and tracking
    'https://www.google-analytics.com/',
    'https://backend.getbeamer.com/',
    'https://stats.g.doubleclick.net',
    'https://*.usercentrics.eu',
    // Travel booking services
    'https://hotelbookerssl.sabre.com',
    'https://ssl.conferma.com',
    'https://media.iceportal.com',
    'https://i.travelapi.com',
    'https://investor.travelctm.com.au',
    'https://fonts.gstatic.com',
    'https://*.pendo.io/',
    'https://arrangemy.com',
    'https://static4.holidayextras.com',
    'https://*.groundspan.com',
    'app.eu.pendo.io',
    'pendo-eu-static-6259707017494528.storage.googleapis.com',
    // Sqills template domains (all environments)
    'https://template.rdg-bat-gw-acc.cloud.sqills.com',
    'https://template.rdg-bat-gw-prod.cloud.sqills.com',
    'https://template.rdg-bat-gr-acc.cloud.sqills.com',
    'https://template.rdg-uk-gr-prod.cloud.sqills.com',
    'https://template.rdg-bat-tp-acc.cloud.sqills.com',
    'https://template.rdg-bat-vt-acc.cloud.sqills.com',
    'https://template.rdg-uk-xc-prod.cloud.sqills.com',
    'https://template.rdg-uk-vt-prod.cloud.sqills.com',
    'https://template.rdg-uk-gw-prod.cloud.sqills.com',
    'https://template.rdg-uk-em-prod.cloud.sqills.com',
    // Evolvi seatmap images (per-TOC S3 buckets, e.g. itp-inv-public-*, s3p-inv-public-*)
    // Required here too because the Angular Service Worker fetches these under connect-src, not img-src
    'https://*.s3.eu-central-1.amazonaws.com'
  ],
  'frame-src': [
    "'self'",
    'https://*.usercentrics.eu',
    'https://*.auth0.com',
    'https://ctmuk-dev.eu.auth0.com',
    'https://wchat.eu.freshchat.com/',
    'https://*.eu.webpush.freshchat.com',
    'https://app.getbeamer.com/',
    'app.eu.pendo.io'
  ],
  'media-src': ['https://scoutfroneasset.blob.core.windows.net'],
  'report-uri': ['https://logserver01.sabstt.com/report_uri/csp-report']
};
